export default __webpack_public_path__ + "static/media/pokeball-outline.1638dff4.svg";